import { isEmpty } from 'lodash'
import styled from 'styled-components'

import theme, { rem } from '../../utils/theme'
import SummaryItem from '../SummaryItem'
import TextOnlyButton from '../TextOnlyButton'
import H4 from '../Typography/H4'

const StyledRemoveWrapper = styled.div`
  & + & {
    margin-top: ${rem(22)};
  }
`

const StyledTitle = styled.div`
  display: flex;
  padding: 0 0 ${rem(5)};

  > h3 {
    font-size: ${theme.typography.fontSizeSm};
    font-weight: ${theme.typography.fontWeightBolder};
    color: ${`var(--gameday-body-headingColor, ${theme.body.headingColor})`};
  }
`

const StyledTitleButtons = styled.div`
  display: flex;
  margin-left: ${rem(20)};
  transform: translateY(${rem(-2)});

  > button + button {
    margin-left: ${rem(10)};
  }
`

const StyledMain = styled.div`
  padding: ${rem(9)} 0;
  border-top: ${theme.borders.default};
  border-bottom: ${theme.borders.default};
`

const StyledGroupHeader = styled(H4)`
  font-size: ${theme.typography.fontSizeSm};
  font-weight: ${theme.typography.fontWeightMedium};
  margin: ${rem(16)} 0 ${rem(8)} 0 !important;
  width: 100%;
`

const defaultRemoveHandler = (e, userHandler, id, itemId) => {
  e.preventDefault()
  if (userHandler) {
    userHandler(id, itemId)
  }
}

const RemoveWrapper = ({
  data,
  onEdit,
  onRemove,
  onRemoveItem,
  formType,
  children,
  summaryIndex,
  formData,
  itemsGroupMap,
  displayPriceAsZero = false,
  isLocked,
}) =>
  // biome-ignore lint/complexity/useOptionalChain: TODO
  data && data.id ? (
    <StyledRemoveWrapper>
      <StyledTitle>
        <h3>{data.title}</h3>
        <StyledTitleButtons>
          {onEdit && (
            <TextOnlyButton
              label="Edit"
              aria-label="Edit"
              onClick={e => {
                defaultRemoveHandler(e, onEdit, data.id)
              }}
              id={`edit-member-${summaryIndex}`}
              disabled={isLocked}
            />
          )}
          <TextOnlyButton
            label="Remove"
            aria-label="Remove"
            onClick={e => {
              defaultRemoveHandler(e, onRemove, data.id)
            }}
            id={`remove-member-${summaryIndex}`}
            disabled={isLocked}
          />
        </StyledTitleButtons>
      </StyledTitle>
      <StyledMain>
        {Object.keys(itemsGroupMap).map(i => {
          const productsInGroup = Object.values(itemsGroupMap[i])
          return (
            <div key={i}>
              {!isEmpty(Object.values(itemsGroupMap[i])) && <StyledGroupHeader>{i}</StyledGroupHeader>}
              {!isEmpty(productsInGroup) &&
                productsInGroup.map((item, index) => (
                  <SummaryItem
                    key={item.id}
                    items={item.items}
                    formType={formType}
                    showRemove={!item.required}
                    removeDisabled={isLocked}
                    onClickRemove={e => {
                      defaultRemoveHandler(e, onRemoveItem, data.id, item.id)
                    }}
                    id={`member-${summaryIndex}-item-${index}`}
                    formData={formData}
                    displayPriceAsZero={displayPriceAsZero}
                    {...item}
                  />
                ))}
            </div>
          )
        })}
        {children}
      </StyledMain>
    </StyledRemoveWrapper>
  ) : (
    ''
  )

export default RemoveWrapper
